import { GQLContract } from '@upheal/graphql/definitions/schema.generated';

export const isCoupleContract = (contract: Pick<GQLContract, 'clients'>) =>
    contract.clients.length > 1;

export const getNextSessionNumber = (
    contract?: Pick<GQLContract, 'sessionsCount'> | null,
) => (contract?.sessionsCount ?? 0) + 1;
